/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */

/**
 * Asset type. By default: `supportingDocument`
 */
export type AssetBodyDtoType =
  (typeof AssetBodyDtoType)[keyof typeof AssetBodyDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AssetBodyDtoType = {
  supportingDocument: 'supportingDocument',
  rra: 'rra',
} as const;
